import {Component, forwardRef, Input, OnInit} from '@angular/core';
import {CommonInputComponent} from '../common-input/common-input.component';
import {FormElementsService} from '../../services/form-elements.service';
import {EMPTY, fromEvent, timer} from 'rxjs';
import {debounce, distinctUntilChanged, map} from 'rxjs/operators';
import {EmployeeRes, LookupLanguage} from '../../../forms/modules/sp/models/osp';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'app-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AutocompleteComponent),
      multi: true
    }
  ]
})
export class AutocompleteComponent extends CommonInputComponent implements OnInit, ControlValueAccessor {
  public options: any[];
  @Input() inputId: string;
  @Input() context: string;
  @Input() displayProperty: string;
  @Input() type: string;
  protected optionObjects: any[];
  private first = true;

  constructor(protected formElementsService: FormElementsService) {
    super();
  }

  ngOnInit(): void {
    this.actualValue = this.ngModelObject;
  }

  public getOptions(value: string): void {
    if (this.inputId) {
      value = value ? value.toLowerCase() : '';
      this.formElementsService.getOptionList(this.inputId, value, this.context).then(res => {
          this.optionObjects = res;
          this.options = this.displayProperty ?
            res.map(option => option[this.displayProperty]) : res.map(option => option.name ? option.name : option);
        }
      );
    }
  }

  public emitChangeToGetOptions(newValue: any, inputElement: HTMLInputElement | HTMLTextAreaElement): void {
    if (this.inputId) {
      if (this.first) {
        fromEvent(inputElement, 'keyup').pipe(
          map((event: any) => {
            return event.target.value;
          })
          , debounce(value => value ? timer(400) : EMPTY)
          , distinctUntilChanged()
        ).subscribe((text: string) => {
          this.modelChanged(text);
        }, (err) => {
          console.log('error', err);
        });
      }
      this.first = false;
    } else {
      this.updateValue(newValue);
      this.emitValue(newValue, (!(this.objectToSet === null || this.objectToSet === undefined)));
    }
  }

  public modelChanged(value: string): void {
    this.updateValue(value);
    if (this.inputId) {
      if (value === '') {
        this.setSelectedOption();
      } else {
        this.emitValue(value);
      }
      this.getOptions(value);
    } else {
      this.emitValue(value);
    }
  }

  public setSelectedOption(event?: any): void {
    const valueToEmit = this.getValueToEmit(event);
    switch (this.inputId) {
      case 'StudyProgramme.employee' :
        const employee = event ? valueToEmit as EmployeeRes : this.getEmptyEmployee();
        this.emitValue(employee, this.objectToSet !== null);
        break;
      case 'StudyProgramme.language':
        const language = valueToEmit as LookupLanguage;
        this.emitValue(language, this.objectToSet);
        break;
      default:
        this.emitValue(valueToEmit, this.objectToSet);
    }
  }

  protected getValueToEmit(event: any): any {
    const value = this.getValueFromOptions(event);
    return this.objectToSet ? value : this.displayProperty ? value[this.displayProperty] : value?.name ? value.name : value;
  }

  protected getValueFromOptions(event: any): any {
    return event ? this.optionObjects.find(obj => {
      return this.displayProperty ? obj[this.displayProperty] === event.option.value : obj.name ?
        obj.name === event.option.value : obj === event.option.value;
    }) : null;
  }

  private getEmptyEmployee(): EmployeeRes {
    return {
      email: null,
      employmentType: null,
      firstName: null,
      fullName: null,
      idDepartment: null,
      idEmployee: null,
      lastName: null,
      login: null,
      phone: null,
      titleAfter: null,
      titleBefore: null,
      web: null,
    };
  }
}
